import { Component, OnInit, Input } from '@angular/core';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import * as _ from 'lodash';
import EstadosJSON from '../../../../utils/estados.json';
import { ViewChild } from '@angular/core';
import { TipoBeneficio } from '../../../_models/Enums/tipoExperiencia';
import { Router } from '@angular/router';

@Component({
  selector: 'app-experiencias',
  templateUrl: './experiencias.component.html',
  styleUrls: ['./experiencias.component.scss'],
})
export class ExperienciasComponent implements OnInit {
  @ViewChild('selectEstado') private selectEstado: any;
  @ViewChild('progressBar') private progressBar: any;
  @Input() public niveis: any[] = [];
  @Input() public idMembro: number = 0;
  @Input() public pontuacaoRestanteProximoNivel: number = 0;
  @Input() public pontosMembro: number = 0;
  @Input() public membroCPF: string = '';

  public nivelSelecionado: number = 5;
  public nivelSelecionadoDescricao: string = 'crush';
  public ultimoNivel: boolean = false;

  public carregandoExperiencias: boolean = false;

  public estadoSelecionado: string = '';
  public estados: any[] = EstadosJSON;

  mouseDown = false;
  startX: any;
  scrollLeft: any;
  slider = document.getElementById('container-experiencias');

  experiencias = [];

  constructor(private fidelidadeService: FidelidadeService, private router: Router) {}

  ngOnInit(): void {
    this.tratarDados();
    this.carregarExperienciasPorNivel();
    // this.calcularPorcentagemProximoNivel();
  }

  private carregarExperienciasPorNivel(): void {
    this.experiencias = [];

    this.carregandoExperiencias = true;

    const tipos = `[${TipoBeneficio.Promocao},${TipoBeneficio.Experiencia}]`;

    this.fidelidadeService
      .obterExperienciasPorPaginaETipos('home', tipos)
      .subscribe({
        next: (res: any) => this.processarSucessoObterExperiencias(res),
        error: (err: any) => this.processarFalhaObterExperiencias(err),
      });
  }

  private processarSucessoObterExperiencias(res: any): void {
    this.experiencias = res.resultado;
    this.processarUltimoNivel(this.idMembro);
    this.carregandoExperiencias = false;
  }

  private processarFalhaObterExperiencias(err: any): void {
    console.error('Ocorreu um erro ao obter as experiências por nível', err);
    this.processarUltimoNivel(this.idMembro);
    this.carregandoExperiencias = false;
  }

  private tratarDados(): void {
    this.nivelSelecionado = this.idMembro;

    //Funcionário deve ficar com o nível amor selecionado
    if(this.nivelSelecionado == 9)
      this.nivelSelecionado = 8;

    this.niveis.forEach((nivel: any) => {
      if (nivel.id === this.nivelSelecionado)
        this.nivelSelecionadoDescricao = nivel.nome.toLowerCase();
    });
  }

  public filtroExperiencias(): any[] {
    return _.filter(this.experiencias, (experiencia: any) => {
      return (
        experiencia.idCategoria !== 15 &&
        (this.estadoSelecionado === '' ||
        experiencia.estados.includes(this.estadoSelecionado) ||
        (experiencia.estados.length === 0 &&
          !experiencia.estadosExcessao.includes(this.estadoSelecionado)))
      );
    });
  }

  startDragging(e, flag, el) {
    this.mouseDown = true;
    this.startX = e.pageX - el.offsetLeft;
    this.scrollLeft = el.scrollLeft;
  }
  stopDragging(e, flag) {
    this.mouseDown = false;
  }
  moveEvent(e, el) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - el.offsetLeft;
    const scroll = x - this.startX;
    el.scrollLeft = this.scrollLeft - scroll;
  }

  selecionarNivel(nivelId: number, index: number): void {
    this.nivelSelecionado = nivelId;
    this.nivelSelecionadoDescricao = this.niveis[index].nome.toLowerCase();
    this.carregarExperienciasPorNivel();
    this.processarUltimoNivel(nivelId);
  }

  private processarUltimoNivel(id: number): void {
    this.ultimoNivel = this.niveis[this.niveis.length - 1].id === id;
  }

  public definirClasseNivel(nivel): string {
    let classe = '';

    if (nivel.id === this.nivelSelecionado) classe += 'nivel--selecionado ';

    const nivelNome = nivel.nome.toLowerCase();
    if (nivelNome === 'amor') classe += 'nivel--amor ';
    else if (nivelNome === 'paquera') classe += 'nivel--paquera ';
    else if (nivelNome === 'paixão') classe += 'nivel--paixao ';

    return classe;
  }

  public calcularPorcentagemProximoNivel() {
    let porcentagem =
      (this.pontosMembro * 100) / this.pontuacaoRestanteProximoNivel;
    porcentagem = porcentagem > 100 ? 100 : porcentagem;

    return {
      width: porcentagem + '%',
    };
  }

  public exibirProgressoProximoNivel(): boolean {
    return this.nivelSelecionado === this.idMembro + 1 && !this.ultimoNivel;
  }

  irParaMomentosEspeciais() {
    this.router.navigate(['/momentos-especiais']);
  }
}
